import styled from 'styled-components';

import { UiButton } from '@/components/ui/Button';
import { UiTypography } from '@/components/ui/Typography';
import { OnboardingPage } from '@/pages/Onboarding/components/Page';

export const PageStyles = styled(OnboardingPage)`
  ion-content {
    &::part(scroll) {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: flex-start;
      margin-top: 16px;
    }

    .content-wrapper {
      position: absolute;
      bottom: 0;
      left: 0;
      right: 0;
      padding: 48px 16px 24px;
      display: flex;
      flex-direction: column;
      align-items: center;
      backdrop-filter: blur(3px);
      z-index: 10;
    }

    .app-logo {
      margin-bottom: 20px;
    }
    .page-title {
      margin-bottom: 100px;
      text-transform: none;
    }
  }
`;

export const PageTitleStyles = styled(UiTypography)`
  font-weight: 900;
  font-size: 24px;
  line-height: 32px;
  text-align: center;
  text-transform: uppercase;

  .ion-page & {
    z-index: 10;
  }
`;

export const PageSubtitleStyles = styled(UiTypography)`
  .ion-page & {
    color: transparent;
  }
`;

export const BottomButtonStyles = styled(UiButton)`
  position: fixed;
  bottom: 34px;
  left: 50%;
  transform: translateX(-50%);
  z-index: 10;
  max-width: 500px;
  height: 48px;
  padding: 0 16px;
`;

export const SubtitleStyles = styled(UiTypography)`
  color: var(--text-color-neutral-white);
  text-align: center;

  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px;
  letter-spacing: 0.25px;
  margin-top: 12px;
  text-transform: none;
`;

export const MainImageStyles = styled.div`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -70%);
  width: 100%;
  z-index: 1;

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    object-position: center;
  }
`;

export const TopImageStyles = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  z-index: 0;

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    object-position: center top;
  }
`;
